module.exports = __webpack_public_path__ + "img/pager2-quick-icon2.fa5548d4.png";